import React from 'react';
import bg from '../images/bg.svg';

export default () => {
    return (
        <div className="alt-page-header-bg" style={{backgroundImage: `url(${bg})`}} />
    )
}